import moment from 'moment';

export const getUploadedTime = dateString => {
	const utcDate = new Date(dateString);
	const myLocalDate = new Date(
		Date.UTC(
			utcDate.getFullYear(),
			utcDate.getMonth(),
			utcDate.getDate(),
			utcDate.getHours(),
			utcDate.getMinutes()
		)
	);

	const today = moment();
	const momentDate = moment(myLocalDate);

	return momentDate.isSame(today, 'day')
		? `at ${momentDate.format('h:mma')} today`
		: `at ${momentDate.format('h:mma')} on ${momentDate.format('MMM D YYYY')}`;
};
